import React, {useState} from "react";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {Dialog} from "../../../../designSystem/components/Dialog";

import {LoginModalContent} from "../LoginModalContent";
import {useLogin} from "../../hooks/useLogin";

export const LoginFeature = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  const { dialogContent, submit, confirmCompleted } = useLogin({ email, password });

  return (
    <React.Fragment>
      <div className="flex justify-center pt-20 px-5">
        <DashboardCard>
          <Typography variant="title">
            登入
          </Typography>

          {/* Email Input */}
          <div className="flex flex-col gap-2">
            <Typography variant="bodyBold">
              Email
            </Typography>
            <BaseInput
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* Password Input */}
          <div className="flex flex-col gap-2">
            <Typography variant="bodyBold">
              密碼
            </Typography>
            <BaseInput
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  submit()
                }
              }}
            />
          </div>

          {/* Login Button */}
          <div className="pt-6">
            <ActionButton
              fullWidth
              label="登入"
              onClick={submit}
            />
          </div>
        </DashboardCard>
      </div>
      <Dialog isOpen={dialogContent !== ''}>
        {LoginModalContent({
          handleCloseDialog: confirmCompleted,
        })[dialogContent] || <></>}
      </Dialog>
    </React.Fragment>
  );
};
